<template>
  <!-- ************************************************** --
    -- 絞り込みダイアログ
    -- ************************************************** -->
    <!-- 実績行 -->
    <v-dialog v-model="showDialog" height="80%" width="650" max-width="90%" style="z-index:500" persistent no-click-animation>
      <v-card>
        <v-toolbar elevation="1" color="#6091d3" dark dense>
          <v-spacer></v-spacer>
          <v-toolbar-title>実績情報絞り込み</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="onClickJissekiFilterClose" text><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row no-gutters align-content="center" class="my-1">
              <div class="px-1" style="font-weight:bold;color:navy">入力した内容で絞り込みされます。</div>
            </v-row>
            <v-row no-gutters align-content="center" class="my-1">
              <v-col :cols="12">
                <v-row no-gutters align-content="center">
                  <v-col :cols="12" class="px-1">
                    実績:
                  <span v-for="item in jissekiFilterConditions" v-bind:key = item.code style="padding:6px">
                      <label>
                      <input type="checkbox" :value="item.code" v-model="item.value" />
                      {{ item.code }}:{{ item.name }}
                      </label>
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickJissekiFilterClose">閉じる</v-btn>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickJissekiFilterClear">クリア</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="2" class="mx-5" text outlined rounded dark style="background:#2F75B5;" min-width="100" @click="onClickJissekiFilterExec">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
// ----- <ここからJavaScript> ------------------------------------------------------------------------------------------------------------------------
//
//
// ************************************************************************************************************************
// <特記事項>
//  mapGetters用のLoadMaster(menuList等の取得)は当コンポーネントを呼び出す画面で実施する事
// ************************************************************************************************************************
//
//
//

// Rahmen Definition アルファベット順記述
import controls from '@/rahmen/controls'
import viewMixin from '@/mixins/viewMixins'

// vue Definition
import { mapGetters } from 'vuex'

export default {
  name: 'DdHaishaJissekiFilterDialog',
  mixins: [viewMixin],

  // 参照コンポーネント定義
  components: {
  },

  // プロパティ定義
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    param: Array
  },

  data: () => ({
    invalidMessage: '',

    // 乗務員フィルター初期値
    jissekiFilterConditions: [
      {
        code: '0',
        name: '',
        value: true
      },
      {
        code: '1',
        name: '',
        value: true
      },
      {
        code: '9',
        name: '',
        value: true
      }
    ],

    // 戻り値用定義
    rec: {
    }
  }),

  created () {
  },

  watch: {
    showDialog: function () {
      if (this.showDialog === true) {
        // ここに表示時やりたいこと書く
        if (this.param && Array.isArray(this.param) && this.param.length > 0) {
          // this.jissekiFilterConditions = Object.assign([], this.param)
          this.jissekiFilterConditions = []
          this.param.forEach((e) => {
            const t = { ...e }
            this.jissekiFilterConditions.push(t)
          })
        } else {
          Object.assign(this.jissekiFilterConditions, this.$options.data().jissekiFilterConditions)
        }
        this.mergeJissekiParam()
      }
    }
  },

  mounted () {
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage, this.$el)

    this.initBindVariables()
  },

  /* **************************************************************************************************** *
   *
   * 算出プロパティ
   *
   * **************************************************************************************************** */
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      shubetsuList: 'DDMasters/mstShubetsu'
    }),
    filteredJissekiShubetsu () {
      const listData = this.shubetsuList.filter(function (elem) {
        return elem.sbtShuruiCd === 'SBTC01'
      }).map(function (elem) {
        elem.code = elem.sbtCd.trim()
        elem.name = elem.sbtNm.trim()
        return elem
      })
      // this.mergeJissekiParam(listData)
      return listData
    }
  },

  /* **************************************************************************************************** *
   *
   * メソッド
   *
   * **************************************************************************************************** */
  methods: {
    initialize: function () {
      // const self = this
      const opt = {
        loadMasters: ['mstshubetsu'],
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
    },
    // --------------------------------------------------------------------------------
    // 閉じるボタン押下
    // --------------------------------------------------------------------------------
    onClickJissekiFilterClose: function (e) {
      this.$emit('close', undefined)
    },
    onClickJissekiFilterExec: function (e) {
      this.$emit('exec', this.jissekiFilterConditions)
    },
    // --------------------------------------------------------------------------------
    // クリアボタン押下
    // --------------------------------------------------------------------------------
    onClickJissekiFilterClear: function (e) {
      Object.assign(this.jissekiFilterConditions, this.$options.data().jissekiFilterConditions)
      this.$emit('exec', this.jissekiFilterConditions)
    },
    mergeJissekiParam () {
      var mst = this.filteredJissekiShubetsu
      this.jissekiFilterConditions.forEach((e) => {
        const m = mst.find((ef) => {
          return ef.code === e.code
        })
        if (m) {
          e.name = m.name
        }
      })
      mst.forEach((e) => {
        const m = this.jissekiFilterConditions.find((ef) => {
          return ef.code === e.code
        })
        if (!m) {
          this.jissekiFilterConditions.push({
            code: e.code,
            name: e.name,
            value: true
          })
        }
      })
    }
  }
}
</script>
<style></style>
